<template>
    <v-form @submit.prevent="submit">
        <v-btn class="v-btn--primary v-btn--google" block @click="loginWithGoogle">
            <img
                alt="google-login"
                :src="googleLogo"
             />
            {{ $t('login.with_google') }}
        </v-btn>
        <div class="o-divider">
            <v-divider></v-divider>
            &nbsp;&nbsp; o &nbsp;&nbsp;
            <v-divider></v-divider>
        </div>
        <span>{{ $t('login.user') }}:</span>
        <v-text-field
            outlined
            dense
            :error-messages="emailErrors"
            class="input-text input-text--text-field"
            v-model="form.email"
            name="login"
            type="text"
        ></v-text-field>
        <span class="input-span">{{ $t('login.password') }}:</span>
        <v-text-field
            outlined
            dense
            class="input-text input-text--text-field"
            v-model="form.password"
            id="password"
            name="password"
            type="password"
        ></v-text-field>
        <div class="forgot-password">
            <a href="">{{ $t('login.forgot_your_password') }}</a>
        </div>
        <v-btn class="v-btn--primary" type="submit" block>
            {{ $t('login.login') }}
        </v-btn>
    </v-form>
</template>

<script>
import _ from "lodash";
import { asset } from "@/helpers";

export default {
    components: {},

    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false,
            }),
        }
    },
    methods: {
        submit() {
            this.form.transform(data => ({
                ...data,
                remember: this.form.remember ? 'on' : '',
            })).post(route('login'), {
                onFinish: () => this.form.reset('password'),
            });
        },

        loginWithGoogle(){
            const data = {};

            const options = {
                preserveState: false,
                preserveScroll: true,
                onFinish: visit => {

                },
                onSuccess: visit => {

                },
            };

            //let's go to google authentication form
            //performs a redirection to google oauth2 process
            //this.$inertia.locationVisit(route('google.auth'), true);
            //this.$inertia.get(route('google.auth'), data, options);

            axios.get(route('google.auth')).then(response => window.location = _.get(response.data, 'redirection'));
        },
    },
    computed: {
        emailErrors() {
            return _.get(this.$page, 'props.errors.email', []);
        },

        googleLogo() {
            return asset('/images/google_logo.png');
        },
    }
};
</script>
